<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        ข้อมูลส่วนตัว
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> ข้อมูลส่วนตัว
          </a>
        </li>
        <li class="active">ข้อมูลส่วนตัว</li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <h3 class="box-title">รายละเอียดข้อมูลส่วนตัว</h3>
              </div>
              <div class="box-body">
                <el-form
                  size="mini"
                  :label-position="label_position"
                  label-width="150px"
                  class="demo-ruleForm"
                  >
                  <div class="row">
                    <div class="col-xs-6">
                      <el-form-item label="ชื่อผู้ใช้งาน (Username)" prop="username">
                        <el-input clearable v-model="formProfile.username" disabled></el-input>
                      </el-form-item>
                      <el-form-item label="ชื่อ" prop="name">
                        <el-input clearable v-model="formProfile.firstname" :disabled="isOper"></el-input>
                      </el-form-item>
                      <el-form-item label="นามสกุล" prop="lastname">
                        <el-input clearable v-model="formProfile.lastname" :disabled="isOper"></el-input>
                      </el-form-item>
                      <el-form-item label="เบอร์โทรศัพท์" prop="phoneNumber">
                        <el-input clearable v-model="formProfile.phoneNumber"  @keypress.native="isNumberKey" maxlength="10" show-word-limit :disabled="isOper"></el-input>
                      </el-form-item>
                      <el-form-item label="อีเมล (E-mail)" prop="email">
                        <el-input v-model="formProfile.email" @keypress.native="checkCharater" :disabled="isOper"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="box-footer" v-if="!isOper">
                    <el-button type="primary" size="small" @click="submitUpdateProfile()">บันทึก</el-button>
                  </div>
                  <div class="changepassword">
                    <h3>จัดการรหัสผ่าน</h3>
                    <div class="row">
                      <div class="col-sm-6">
                        <el-form-item label="รหัสผ่านเดิม">
                          <el-input
                            placeholder="กรุณากรอกรหัสผ่านเดิม"
                            v-model="password"
                            show-password
                            @keypress.native="checkCharater"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="รหัสผ่านใหม่">
                          <el-input
                            placeholder="กรุณากรอกรหัสผ่านใหม่"
                            v-model="newpassword"
                            show-password
                            @keypress.native="checkCharater"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="ยืนยันรหัสผ่านใหม่">
                          <el-input
                            placeholder="กรุณากรอกยืนยันรหัสผ่านใหม่"
                            v-model="conpassword"
                            show-password
                            @keypress.native="checkCharater"
                          ></el-input>
                        </el-form-item>
                        <div class="box-footer">
                          <el-button type="primary" size="small" @click="submitChangePass()">บันทึก</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="changepassword">
                    <h3>ส่งคำร้องขอลบบัญชี</h3>
                      <div class="box-footer">
                        <el-button type="danger" size="small" @click="handleView1">แจ้งลบบัญชี</el-button>
                      </div>
                  </div>
                  <modalPasswordConfirm
                    :info="info"
                    :dialog="dialog"
                    @checkModal="closeModal"
                    width="10%"
                  ></modalPasswordConfirm>
                  <!-- <el-dialog
                    :info="info"
                    :visible.sync="dialog"
                    @checkModal="closeModal"
                    width="400px"
                  ></el-dialog> -->
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import modalPasswordConfirm from "../Modal/Modal_password_confirm"
export default {
  components: {
    modalPasswordConfirm
  },
  data() {
    return {
      dialog: false,
      info: '',
      checkList: "",
      label_position: "top",
      value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      value: [0.32, 0.945],
      password: null,
      newpassword: null,
      conpassword: null,
      isOper: this.$cookies.get('user_nbtc').provider_id != null ? true : false
    };
  },
  computed: {
    ...mapState({
      formProfile: store => store.Manage_user.formProfile,
      confirm_modal: store => store.Manage_user.confirm_modal
    })
  },
  created() {},
  mounted() {
    this.getUser();
  },
  methods: {
    ...mapActions({
      getUser: "Manage_user/getUser",
      updateProfile: "Manage_user/updateProfile",
      changePassword: "Manage_user/changePassword",
      comparePassword: "Manage_user/comparePassword",
      deleteAccountRequest: "Manage_user/deleteAccountRequest"
    }),
    checkEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){
        return (true)
      }
        return (false)
    },
    submitUpdateProfile() {
      if(!this.checkEmail(this.formProfile.email)){
        this.$confirm("รูปแบบอีเมลไม่ถูกต้อง", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      } else {
        this.updateProfile()
      }
    },
    submitChangePass() {
      this.changePassword({password:this.password,newpassword:this.newpassword,conpassword:this.conpassword});
    },
    handleView1() {
      const h = this.$createElement;
        this.$msgbox({
          title: 'ยืนยันรหัสผ่าน',
          message: h('p', null, [
            h('span', null, 'เพื่อยืนยันการแจ้งขอลบบัญชี กรุณากรอกรหัสผ่าน ')
          ]),
          showCancelButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          showInput: true,
          inputType: 'password',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              if (instance.inputValue == '' || instance.inputValue == null) {
                this.$message({
                  type: 'warning',
                  message: 'กรุณากรอกรหัสผ่าน'
                });
              } else {
                this.checkPassword(instance.inputValue).then(res => {
                  if (res) {
                    done()
                  } else {
                    this.$message({
                      type: 'error',
                      message: 'รหัสผ่าน ไม่ถูกต้อง'
                    });
                  }
                })
              }
            } else {
              done();
            }
          }
        }).then(action => {
          // this.$confirm('คุณกำลังต้องการยกเลิกการใช้งานในบัญชีของคุณ\nระบบจะทำการส่งคำร้องในการขอลบบัญชีผู้ใช้งานของคุณให้กับผู้ดูแลระบบ\n\nบัญชีผู้ใช้งานของคุณจะถูกยกเลิกหลังจากที่ผู้ดูแลระบบตรวจสอบและอนุมัติใบคำขอ\nหากมีการเปลี่ยนแปลงกรุณาติดต่อผู้ดูแลระบบได้โดยตรง', 'ยืนยันการส่งคำร้องขอลบบัญชี',{
          //   confirmButtonText: "ยืนยัน",
          //   cancelButtonText: "ยกเลิก",
          //   showCancelButton: true
          // }).then(() => {
          //   this.deleteAccountRequest(this.formProfile)
          // }).catch(() => {})
          this.$msgbox({
            title: 'ยืนยันการส่งคำร้องขอลบบัญชี',
            message: h('p', null, [h('p', null, 'คุณกำลังต้องการยกเลิกการใช้งานในบัญชีของคุณ'),h('p', null, 'ระบบจะทำการส่งคำร้องในการขอลบบัญชีผู้ใช้งานของคุณให้กับผู้ดูแลระบบ'),h('br', null, null),h('p', null, 'บัญชีผู้ใช้งานของคุณจะถูกยกเลิกหลังจากที่ผู้ดูแลระบบตรวจสอบและอนุมัติใบคำขอ'),h('p', null, 'หากมีการเปลี่ยนแปลงกรุณาติดต่อผู้ดูแลระบบได้โดยตรง')]),
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                done()
              } else {
                done();
              }
            }
          }).then(action => {
            this.deleteAccountRequest(this.formProfile)
          }).catch(cancel => {
            console.log(cancel)
          })
        }).catch(cancel => {
          console.log(cancel)
        })
    },
    handleView() {
      this.dialog = true;
      this.info = this.$cookies.get('user_nbtc');
    },
    closeModal(value) {
      this.dialog = value;
      this.requestDialog = value
    },
    async checkPassword(password) {
      let user_data = {
        admin_id: this.formProfile.admin_id,
        password: password
      }
      let result = await this.comparePassword(user_data)
      return result
    }
  }
};
</script>
